var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFolderBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5V8.75H21V6.625H10.375V4.5H4ZM4 10.875V20.4375C4 21.0325 4.4675 21.5 5.0625 21.5H19.9375C20.5325 21.5 21 21.0325 21 20.4375V10.875H4Z",
    fill: "#241D6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderBlack);
export default __webpack_public_path__ + "static/media/icon-folder-black.52f104a5bac0455acb2200021a075337.svg";
export { ForwardRef as ReactComponent };